var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEssentiaExperienceP(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1819",
    "data-name": "Grupo 1819",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.162,
    height: 55.159,
    viewBox: "0 0 87.162 55.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1260",
    "data-name": "Ret\\xE2ngulo 1260",
    width: 87.162,
    height: 55.159,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_753",
    "data-name": "Caminho 753",
    d: "M.043,328.565V341.49H8.9v-2H2.31v-3.585H8.763v-2H2.31v-3.352H8.9v-2Z",
    transform: "translate(-0.039 -299.116)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1815",
    "data-name": "Grupo 1815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1814",
    "data-name": "Grupo 1814",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_754",
    "data-name": "Caminho 754",
    d: "M116.751,335.957a5.575,5.575,0,0,0,4.089,1.783c1.86,0,2.6-.911,2.6-1.763,0-1.163-1.376-1.512-2.945-1.918-2.112-.523-4.593-1.143-4.593-3.875,0-2.132,1.88-3.779,4.709-3.779a6.725,6.725,0,0,1,4.844,1.8l-1.3,1.686a5.254,5.254,0,0,0-3.74-1.473c-1.337,0-2.19.639-2.19,1.608,0,1.008,1.318,1.337,2.848,1.724,2.132.543,4.67,1.2,4.67,4.011,0,2.151-1.511,3.992-5,3.992a6.915,6.915,0,0,1-5.251-2.054Z",
    transform: "translate(-105.14 -297.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_755",
    "data-name": "Caminho 755",
    d: "M245.171,335.957a5.575,5.575,0,0,0,4.089,1.783c1.86,0,2.6-.911,2.6-1.763,0-1.163-1.376-1.512-2.945-1.918-2.112-.523-4.593-1.143-4.593-3.875,0-2.132,1.88-3.779,4.709-3.779a6.725,6.725,0,0,1,4.844,1.8l-1.3,1.686a5.254,5.254,0,0,0-3.74-1.473c-1.337,0-2.19.639-2.19,1.608,0,1.008,1.318,1.337,2.848,1.724,2.132.543,4.67,1.2,4.67,4.011,0,2.151-1.511,3.992-5,3.992a6.915,6.915,0,0,1-5.251-2.054Z",
    transform: "translate(-222.05 -297.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_756",
    "data-name": "Caminho 756",
    d: "M381.627,328.565h8.856v2h-6.588v3.352h6.453v2h-6.453v3.585h6.588v2h-8.856Z",
    transform: "translate(-347.423 -299.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_757",
    "data-name": "Caminho 757",
    d: "M508.639,332.073v9.418h-2.267V328.566H508.7l6.608,9.166v-9.166h2.267V341.49h-2.19Z",
    transform: "translate(-460.987 -299.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_758",
    "data-name": "Caminho 758",
    d: "M656.648,330.561h-3.914v-2h10.1v2h-3.914V341.49h-2.267Z",
    transform: "translate(-594.231 -299.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1258",
    "data-name": "Ret\\xE2ngulo 1258",
    width: 2.267,
    height: 12.925,
    transform: "translate(70.517 29.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_759",
    "data-name": "Caminho 759",
    d: "M837.186,339.01h-6.123l-.95,2.48h-2.48l5.077-12.925h2.829l5.077,12.925h-2.48Zm-5.484-2h4.845l-2.422-6.53Z",
    transform: "translate(-753.454 -299.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_760",
    "data-name": "Caminho 760",
    d: "M0,527.136H5.221v1.026H1.166v2.273H5.14v1.026H1.166v2.424H5.221v1.026H0Z",
    transform: "translate(0 -479.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_761",
    "data-name": "Caminho 761",
    d: "M95.552,531.74l-2.331,3.17h-1.41l2.984-3.986-2.809-3.788H93.4l2.156,2.984,2.144-2.984h1.41l-2.785,3.776,2.96,4h-1.4Z",
    transform: "translate(-83.582 -479.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_762",
    "data-name": "Caminho 762",
    d: "M211.839,527.136h3.275a2.391,2.391,0,1,1,0,4.778H213v3h-1.165Zm3.124,1.026H213v2.727h1.958a1.365,1.365,0,1,0,0-2.727",
    transform: "translate(-192.852 -479.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_763",
    "data-name": "Caminho 763",
    d: "M315.48,527.136H320.7v1.026h-4.056v2.273h3.974v1.026h-3.974v2.424H320.7v1.026H315.48Z",
    transform: "translate(-287.205 -479.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_764",
    "data-name": "Caminho 764",
    d: "M418.625,531.914h-1.457v3H416v-7.774h3.275a2.317,2.317,0,0,1,2.494,2.389,2.168,2.168,0,0,1-1.935,2.273l1.993,3.112h-1.352Zm.5-3.753h-1.958v2.727h1.958a1.366,1.366,0,1,0,0-2.727",
    transform: "translate(-378.718 -479.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1259",
    "data-name": "Ret\\xE2ngulo 1259",
    width: 1.165,
    height: 7.774,
    transform: "translate(46.808 47.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_765",
    "data-name": "Caminho 765",
    d: "M580.507,527.136h5.221v1.026h-4.056v2.273h3.974v1.026h-3.974v2.424h4.056v1.026h-5.221Z",
    transform: "translate(-528.477 -479.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_766",
    "data-name": "Caminho 766",
    d: "M682.2,528.943v5.967H681.03v-7.774h1.2l4.231,5.827v-5.827h1.166v7.774H686.5Z",
    transform: "translate(-619.991 -479.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_767",
    "data-name": "Caminho 767",
    d: "M796.246,529.727a3.892,3.892,0,0,1,3.986-4.021,3.515,3.515,0,0,1,3.089,1.643l-.991.524a2.464,2.464,0,0,0-2.1-1.13,2.991,2.991,0,0,0,0,5.967,2.464,2.464,0,0,0,2.1-1.13l.991.524a3.53,3.53,0,0,1-3.089,1.643,3.892,3.892,0,0,1-3.986-4.021",
    transform: "translate(-724.88 -478.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_768",
    "data-name": "Caminho 768",
    d: "M914.193,527.136h5.221v1.026h-4.056v2.273h3.974v1.026h-3.974v2.424h4.056v1.026h-5.221Z",
    transform: "translate(-832.257 -479.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_769",
    "data-name": "Caminho 769",
    d: "M396.012,23.72l-2.827,2.827L394.6,27.96l-.707.707-.707-.707-.707-.707-1.414,1.414-.707-.707,1.416-1.416h0l-2.12-2.12h0l-2.121,2.121,0,0,1.414,1.414-.705.705-2.121-2.121,3.255-3.255h4.242l-1.841,1.841.707.707,2.548-2.548h0l1-1h-7.07L384.7,26.546l.707.707,0,0,2.121,2.121.707.707.707-.707.705-.705.707.707-.707.707-.707.707,1.414,1.414-.707.707-1.416-1.416h0l-2.12,2.12.707.707.709.709h0l.707.707,1.414-1.414.705.705-2.121,2.121-3.255-3.256V29.651l1.841,1.841.707-.707-2.548-2.548v0l-1-1v0h0V34.3h0l4.258,4.258.707-.707,0,0,2.828-2.828-1.412-1.412.707-.707.707.707.707.707,1.414-1.414.707.707L393.18,35.03h0l2.12,2.12,1.416-1.416.705-.705,0,0-1.414-1.414.705-.705,2.121,2.121-3.255,3.255h-4.241l1.841-1.841-.707-.707-2.548,2.548h0l-1,1h7.07l4.258-4.258-.707-.707,0,0L397.422,32.2l-.707-.707-.707.707-.705.705L394.6,32.2l.707-.707.707-.707L394.6,29.373l.707-.707,1.416,1.416h0l2.12-2.12-.707-.707-.709-.709-.705-.705,0,0L395.3,27.253l-.705-.705,2.121-2.121,3.255,3.255v4.242l-1.841-1.841-.707.707,2.548,2.548v0l1,1v0h0V27.27h0l-4.258-4.258-.707.707Zm-7.071,2.826.709-.709.707.707-.709.709Zm-.707,7.776-.709-.709.707-.707.709.709Zm7.776.707-.709.709-.707-.707.709-.709Zm-3.534-6.362.707.707-.707.707-.707-.707Zm-2.121,2.121.707-.707.707.707-.707.707Zm2.121,2.121-.707-.707.707-.707.707.707Zm2.121-2.121-.707.707-.707-.707.707-.707Zm2.121-3.534.709.709-.707.707-.709-.709Z",
    transform: "translate(-349.561 -20.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_770",
    "data-name": "Caminho 770",
    d: "M376.532,0h-8.7l-6.149,6.149v8.7l6.149,6.149h8.7l6.149-6.149v-8.7Zm5.149,14.431-5.563,5.563H368.25l-5.563-5.563V6.563L368.25,1h7.868l5.563,5.563Z",
    transform: "translate(-329.27)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentiaExperienceP);
export default __webpack_public_path__ + "static/media/essentia-experience-p.2fa5d6cdf4b65ad0015bcdc57e9f7d9b.svg";
export { ForwardRef as ReactComponent };